import {
  GET_REPORT_PENDING,
  GET_REPORT_SUCCESS,
  GET_REPORT_ERROR,
  TOGGLE_REPORT_MODAL,
  CANCEL_REPORT,
  GET_REPORT_FINISH,
  REPORT_IN_A_QUEUE,
  CLOSE_REPORT_MODAL,
  GET_HISTORY_REPORTS_LIST_SUCCESS,
} from '../constants/ActionTypes';

export const initialState = {
  isReportModalOpened: false,
  isReportCreationInProgress: false,
  isReportInQueue: false,
  selectedReport: null,
  historyReportList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_PENDING:
      return {
        ...state,
        isReportCreationInProgress: true,
      };
    case GET_REPORT_SUCCESS:
      return {
        ...state,
        isReportCreationInProgress: false,
        isReportModalOpened: !state.isReportModalOpened,
      };
    case GET_REPORT_ERROR:
      return {
        ...state,
        isReportCreationInProgress: false,
        isReportModalOpened: !state.isReportModalOpened,
      };
    case REPORT_IN_A_QUEUE: {
      return {
        ...state,
        isReportInQueue: true,
      };
    }
    case TOGGLE_REPORT_MODAL:
      return {
        ...state,
        isReportModalOpened: !state.isReportModalOpened,
        isReportCreationInProgress: false,
        isReportInQueue: false,
        selectedReport: action.payload.selectedReport,
      };
    case CANCEL_REPORT:
      return {
        ...state,
        isReportModalOpened: !state.isReportModalOpened,
        isReportCreationInProgress: false,
        isReportInQueue: false,
        selectedReport: null,
      };
    case GET_REPORT_FINISH:
      return {
        ...initialState,
        isReportInQueue: state.isReportInQueue,
        historyReportList: state.historyReportList,
      };
    case CLOSE_REPORT_MODAL:
      return {
        ...initialState,
        historyReportList: state.historyReportList,
      };
    case GET_HISTORY_REPORTS_LIST_SUCCESS:
      return {
        ...state,
        historyReportList: action.payload,
      };
    default:
      return state;
  }
};
